const styleToggleBtn = document.querySelector('.style-toggle-btn')
const toggleBtnStyles = styleToggleBtn.querySelectorAll('span');
const lifestyleStyle = styleToggleBtn.querySelector('.lifestyle-view');

const changeProductImages = () => {
	const productMainImgWrappers = document.querySelectorAll(".product-link .product-item__bg");

	productMainImgWrappers.forEach((wrapper) => {
		const currentMainImg = wrapper.firstChild.querySelector('img')
		console.log('🚀 ~ file: style-toggling.js:9 ~ productMainImgWrappers.forEach ~ wrapper:', wrapper)
		const currentHoverImg = wrapper.closest('.product-link').querySelector('.product-item__bg__under img') ? wrapper.closest('.product-link').querySelector('.product-item__bg__under img') : null

		if (currentHoverImg) {
			
			let newMainImgSrc
			let newHoverImgSrc

			if (lifestyleStyle.classList.contains('hidden')) {
				newMainImgSrc = wrapper.dataset.lifestyleImage
				newHoverImgSrc = wrapper.dataset.productImage
			} else {
				newMainImgSrc = wrapper.dataset.productImage
				newHoverImgSrc = wrapper.dataset.lifestyleImage
			}

			if (newMainImgSrc && newHoverImgSrc) {
				currentMainImg.setAttribute("src", newMainImgSrc)
				currentMainImg.setAttribute("srcset", newMainImgSrc)

				currentHoverImg.setAttribute("src", newHoverImgSrc)
				currentHoverImg.setAttribute("srcset", newHoverImgSrc)
			}
		}
	})
}

const changeBtnContent = () => {
	toggleBtnStyles.forEach(span => {
		span.classList.toggle('hidden')
	});
}

styleToggleBtn.addEventListener('click', (() => {
	changeProductImages()
	changeBtnContent()
}))